import { Outlet, ScrollRestoration } from 'react-router'
import { useTranslation } from 'react-i18next'
import { OfflineBanner } from './offline-banner'

export function RootLayout() {
  const { t } = useTranslation()
  return (
    <>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[70] focus:rounded-control focus:bg-surface focus:px-4 focus:py-3 focus:text-fg focus:shadow-float"
      >
        {t('common.skipToContent')}
      </a>
      {/* Covers content scrolling under the translucent iOS status bar (zero height elsewhere). */}
      <div aria-hidden className="fixed inset-x-0 top-0 z-[35] h-[env(safe-area-inset-top)] bg-background" />
      <OfflineBanner />
      <Outlet />
      <ScrollRestoration />
    </>
  )
}
